<template>
  <div class="probox">
    <div class="con">
      <div class="intro">
        <img :src="imgPath" />
        <p v-html="introName" class="introName"></p>
        <p v-html="introSubName" class="introSubName"></p>
      </div>
    </div>
    <button @click="wechat()" class="gotoWechat">查看详细介绍</button>
  </div>
</template>

<style scoped>
.probox {
  width: 264px;
  height: 500px;
}

.con {
  background-color: #ffffff;
  width: 264px;
  height: 427px;
  border-top: 4px solid #409eff;
  border-left: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
  user-select: none;
  overflow: hidden;
}
.con:hover {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
}
.con > .intro {
  width: 100%;
  height: 100%;
  position: relative;
}
.intro > img {
  margin-top: 32px;
  width: calc(100% - 32px);
  margin-left: 16px;
}
.intro > .introName {
  position: absolute;
  bottom: 58px;
  left: 0;
  right: 0;
  font-size: 18px;
  color: #303133;
  text-align: center;
}
.intro > .introSubName {
  position: absolute;
  bottom: 16px;
  left: 0;
  right: 0;
  font-size: 16px;
  color: #909399;
  text-align: center;
}
.gotoWechat {
  width: 120px;
  height: 44px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  background-color: #ffffff;
  display: block;
  margin: 14px auto;
  cursor: pointer;
}
</style>

<script>
export default {
  name: "ProductCard",
  props: ["imgPath", "introName", "introSubName", "link"],
  methods: {
    wechat() {
      window.open(this.link);
    }
  }
};
</script>
